const locale = require('./dynamicGrid.i18n.json');

/*@ngInject*/
const DynamicGridController = function ($rootScope, $scope, $filter, $stateParams, options, localization, coreMediator, coreConstant, loadingBarHandler,
        advancedFilterType, filterType, dataSetType, dynamicDataRepository, modalUtil, gridDataBrowserConstant)
{
    $scope.i18n = locale;
    $scope.translations = locale;
    $scope.title = 'Demo Dynamic Grid';
    $scope.showSelector = true;
    $scope.singleSelect = false;
    $scope.dataName = "producer";
    $scope.context = { submissionId: $stateParams.submissionId, formId: $stateParams.formId };
    $scope.selected = [];
    $scope.cancelButton = 'Cancel';
    $scope.okButton = 'Select';
    $scope.thirdButton = "No Match";
    $scope.columns = [
    ];
    $scope.advancedFilterType = 'dynamicGrid';
    $scope.filterType = 101;

    $scope.initialRequestParams = {
            key: 'name',
            sortType: 'asc',
            startIndex: 0,
            pageSize: 25
    };

    if (options.customOptions) {
        if (options.customOptions.confirmationTitle) {
            $scope.title = options.customOptions.confirmationTitle;
        }
        if (options.customOptions.yesButtonLabel) {
            $scope.okButton = options.customOptions.yesButtonLabel;
        }
        if (options.customOptions.noButtonLabel) {
            $scope.cancelButton = options.customOptions.noButtonLabel;
        }
        if (options.customOptions.processingIndicatorText) {
            $scope.processingIndicatorText = options.customOptions.processingIndicatorText;
        }
        if (options.customOptions.parameters) {
            $scope.parameters = JSON.parse(options.customOptions.parameters);
            Object.assign($scope, $scope.parameters);
        }
    }
    else {
        $scope.view = $stateParams.view;
    }

    // get more details about the context from the function button triggering this
    if (options.context) {
        Object.assign($scope.context, options.context);
    }

    $scope.stateParams = {
        browser: 'um.dynamicGrid',
        getDetailState: function (input) {
        }
    };

    // load configuration from system preference system.views.<view> using $scope.view
    if ($scope.view) {
        $scope.advancedFilterType = $scope.view;
        coreMediator.loadDefaultPreferences().then(function (preferences) {
            let prefKey = 'system.views.' + $scope.view;
            if (preferences[prefKey]) {
                let prefValue = preferences[prefKey].value;
                let viewProps = JSON.parse(prefValue);
                Object.assign($scope, viewProps);
                if (viewProps.columns) {
                    _.each(viewProps.columns, (column) => {
                        column.getValue = function(item) {
                            return item[column.valueProp];
                        }
                    });
                }
            }
            // still make the function button parameters overwrite the system preferences since the button config is easier to change
            if (options.customOptions) {
                if (options.customOptions.confirmationTitle) {
                    $scope.title = options.customOptions.confirmationTitle;
                }
                if (options.customOptions.yesButtonLabel) {
                    $scope.okButton = options.customOptions.yesButtonLabel;
                }
                if (options.customOptions.noButtonLabel) {
                    $scope.cancelButton = options.customOptions.noButtonLabel;
                }
                if (options.customOptions.processingIndicatorText) {
                    $scope.processingIndicatorText = options.customOptions.processingIndicatorText;
                }
                if (options.customOptions.parameters) {
                    $scope.parameters = JSON.parse(options.customOptions.parameters);
                    Object.assign($scope, $scope.parameters);
                }
            }
        });
    }

    // load the default filter using $scope.context
    $scope.loadFilterHandler = function () {
        return dynamicDataRepository.getFilter($scope.dataName, $scope.filterType, $scope.context).then(function(result) {
            return result;
        });
    };

    // load grid data items
    $scope.loadItemsHandler = function (filterUri, requestParams) {
      if ($scope.width) {
        $('.modal-content').width($scope.width);
      }
      if ($scope.height) {
        $('.modal-content').height($scope.height);
      }
      let criteria = {
                sortBy: requestParams.key,
                sortDirection: requestParams.sortType,
                startIndex: requestParams.startIndex,
                maxResults: requestParams.pageSize
        };
      criteria.context = $scope.context;
        return dynamicDataRepository.find($scope.dataName, criteria, filterUri).then(function(result) {
            $scope.result = {totalRecords: result.count, records: result.items};
          // save the items not in current display list separately
        $scope.selectedOutOfResults = [];
          if (result.selectedItems) {
            $scope.selected = result.selectedItems;
                _.each(result.selectedItems, (item) => {
                  let exists = false;
                    _.each(result.items, (existing) => {
                      // use toString to compare just in case some ids are saved as string, some as number
                      if (item["id"] && existing["id"] && item["id"].toString()===existing["id"].toString()) {
                        exists = true;
                      }
                    });
                    if (!exists) {
                      $scope.selectedOutOfResults.push(item);
                    }
                });
          }
            return $scope.result;
        });
    };

    // not really used -- just to fill parameters for gridDataBrowser
    $scope.action = {name:"Select", valid:true, enabled:true, buttonBarAction:true, /*isBulkAction:true,*/ bulkActionLabel:'Confirm', defaultExecute:true};
    $scope.loadActionsHandler = function () {
        return coreMediator.loadDefaultPreferences().then(function (preferences) {
            return {actions: [$scope.action]};
        });
    };

    // not really used -- just to fill parameters for gridDataBrowser
    $scope.handleAction = function (action, file) {
        if (action.enabled) {
            switch (action.name) {
//                default:
//                    modalUtil.showActionNotImplementedModal(action.name);
//                    break;
            }
        }
    };

    // not really used -- just to fill parameters for gridDataBrowser
    $scope.handleBulkAction = function (action, selectedItems, excludedItems, filterUri) {
        if (action.enabled) {
            switch (action.name) {
                default:
                    return dynamicDataRepository.execute($scope.dataName, action.name, {data:selectedItems}).then(function(result) {
                        return result;
                    });
                    $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
                    break;
            }
        }
    };

    // track selected items independent of gridDataBrowser
    $scope.$on(coreConstant.event.gridSelectionChanged, function(event, selected) {
      $scope.selected = $scope.selectedOutOfResults.concat([]);
      // only add items not in the non-display selected set
        _.each(selected, (item) => {
          let exists = false;
            _.each($scope.selected, (existing) => {
              if (item["id"] && existing["id"] && item["id"].toString()===existing["id"].toString()) {
                exists = true;
              }
            });
            if (!exists) {
              $scope.selected.push(item);
            }
        });
    });

    // main action
    $scope.onOk = function () {
        let target = {name:$scope.dataName, context:$scope.context, count:$scope.selected.length, items:$scope.selected};
        loadingBarHandler.showLoadingBar($scope.processingIndicatorText);
        return dynamicDataRepository.execute($scope.dataName, $scope.okButton, target).then(function(result) {
            loadingBarHandler.hideLoadingBar();
            $scope.$close();
            return result;
        });
    };

    $scope.onThirdButton = function () {
        let target = {name:$scope.dataName, context:$scope.context, count:$scope.selected.length, items:$scope.selected};
        loadingBarHandler.showLoadingBar($scope.processingIndicatorText);
        return dynamicDataRepository.execute($scope.dataName, $scope.thirdButton, target).then(function(result) {
            loadingBarHandler.hideLoadingBar();
            $scope.$close();
            return result;
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, () => {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

};

angular.module('gw-um-extensions')
    .controller('dynamicGridController', DynamicGridController);
